import React, {FC} from 'react';
import styled from 'styled-components';

import {KeyboardActionsEnum} from '../../../../libs/shared/helpers/src/browser/keyboardHelpers';
import {Trans} from '../../../../libs/shared/helpers/src/internationalization/react';
import {Handler} from '../../../../libs/shared/helpers/src/react/reactHelpers';
import {KeyboardShortcuts} from '../../../../libs/shared/ui/src/components/keyboard/keyboardShortcuts';
import {CenteredPopover} from '../../../../libs/shared/ui/src/components/popovers/centeredPopover';
import {fontSizes, fontWeights} from '../../../../libs/shared/ui/src/styles/fontStyles';
import {InviteTeammatePopoverState} from '../../../store/panels/app/appPanelState';
import {InviteTeammatePopoverFormContainer} from './inviteTeammatePopoverFormContainer';

/*
 * Props.
 */

interface InviteTeammatePopoverProps {
  state: InviteTeammatePopoverState | undefined;
  onRequestClose: Handler;
}

/*
 * Style.
 */

const StyledWrapperDiv = styled.div`
  width: 500px;
  border-radius: 16px;
  background: ${(p) => p.theme.foreground};
`;

const StyledHeaderDiv = styled.div`
  padding: 16px 0;
  text-align: center;
  font-size: ${fontSizes.large};
  font-weight: ${fontWeights.semibold};
  color: ${(p) => p.theme.greys.shade80};
`;

const StyledSeparatorDiv = styled.div`
  height: 1px;
  background-color: ${(p) => p.theme.greys.shade40};
`;

const StyledFormWrapperDiv = styled.div`
  padding: 20px;
`;

/*
 * Component.
 */

export const InviteTeammatePopover: FC<InviteTeammatePopoverProps> = (props) => {
  const {state, onRequestClose} = props;
  if (!state) {
    return null;
  }

  const keyHandlers = {
    [KeyboardActionsEnum.CLOSE]: () => {
      props.onRequestClose();
    },
  };

  return (
    <KeyboardShortcuts handlers={keyHandlers} requestExclusivity>
      <CenteredPopover>
        <StyledWrapperDiv data-testid="invite-teammate-popover">
          <StyledHeaderDiv>
            <Trans id="invite-teammate-popover-header">Invite</Trans>
          </StyledHeaderDiv>
          <StyledSeparatorDiv />
          <StyledFormWrapperDiv>
            <InviteTeammatePopoverFormContainer
              closePopover={onRequestClose}
              accessPoint={state.accessPoint}
            />
          </StyledFormWrapperDiv>
        </StyledWrapperDiv>
      </CenteredPopover>
    </KeyboardShortcuts>
  );
};
